let dev = "https://desarrollo.api.prami.com.co";
let prod = "https://prodapi.prami.com.co";
let local = "http://localhost:8080";
let localCloud = "http://localhost:8081";
let localCreditCore = "http://localhost:8081";
let localReportes = "http://127.0.0.1:8000";
let prodReportes = "https://st4igt7q7il255yy34adhbrzqa0wxxin.lambda-url.us-east-2.on.aws";
let prodCloud = "https://clouds.prami.com.co";
let development = "https://desarrollo.prami.com.co";
let prodCreditcore = "https://credit.core.api.prami.com.co"

export const API_URL = prod;
export const API_CLOUD = prodCloud;
export const API_CREDIT_CORE = prodCreditcore;
export const API_REPORTS = prodReportes;
export const API_CASES_DEMO = "https://demo.prami.com.co/api";
export const CASES_WEBHOOK_URL = "https://webhook.site/d7556672-fe0c-4a8d-bdf7-9f254150d1db";



let items = {
  Dashboard: "/homeAdmin/dashboard",
  Solicitudes: "/homeAdmin/solicitudes",
  Cobranza: "/homeAdmin/cobranza",
  "Chat cobranza": "/homeAdmin/chat-cobranza",
  Comercios: "/homeAdmin/comercios",
  Clientes: "/homeAdmin/clientes",
  Fondeadores: "/homeAdmin/fondeadores",
  "Gestion Manual": "/homeAdmin/gestion-manual",
  Reportes: "/homeAdmin/reportes",
  "Validación informes": "/homeAdmin/validacion-informes",
  Parametros: "/homeAdmin/modify-parameters",
  Politicas: "/homeAdmin/politicas",
  Asignaciones: "/homeAdmin/asignaciones",
  "Novedades siigo": "/homeAdmin/novedades-siigo",
  "Create commerce form": "/homeAdmin/create-commerce-form",
  "Flujos WhatsApp": "/homeAdmin/flujos-whatsapp",
  Scores: "/homeAdmin/scores",
  "Edit commerce form": "/homeAdmin/edit-commerce-form",
  "Campanas": "/homeAdmin/campanas",
  "Expedición certificados": "/homeAdmin/expedicion-certificados",
  "Contabilidad Siigo": "/homeAdmin/contabilidad-siigo",
  Condonaciones: "/homeAdmin/condonaciones",
};

export const MENU_ITEMS = items;

let tiposMensajes = {
  enviado: "Enviado",
  recibido: "Recibido",
};

let tiposDocumentos = {
  text: "text",
  image: "image",
  video: "video",
  document: "document",
  interactive: "interactive",
  audio: "audio",
};

export const TIPOS_MENSAJES = tiposMensajes;
export const TIPOS_DOCUMENTOS = tiposDocumentos;
export const CELL_PHONE_COBRANZA = "573053287631";
